<script>
import { includes, lowerCase, startCase } from 'lodash'

export default {
  name: 'PlaybackFieldPickerButton',
  props: {
    // Public: Array containing field tokens and examples of data in the form of objects `{ name: '<Field>', example: 'Some data' }`
    fields: { type: Array, default: () => [] },
  },
  data () {
    return {
      show: false,
      filteringBy: '',
    }
  },
  computed: {
    filteredFields () {
      if (!this.filteringBy) return this.fields

      const lowerFilteringBy = lowerCase(this.filteringBy)
      return this.fields.filter(field => {
        return includes(lowerCase(field.label), lowerFilteringBy)
      })
    },
  },
  methods: {
    startCase,
    toggleDropdown () {
      this.show = !this.show
    },
    onFieldUse (field) {
      this.show = false
      this.$emit('usePlaybackField', field)
    },
  },
}
</script>

<template>
  <SearchDropdown
    v-model="filteringBy"
    :show="show"
    closeOnClick
    class="playback-field-picker"
    contentClass="options"
    position="right"
    @searchDropdown:expanded="show = $event"
  >
    <Button
      slot="dropdownToggle"
      compact
      icon="add"
      label="Add Playback"
      @click="toggleDropdown"
    />
    <div class="playback-field-container">
      <div v-if="filteredFields.length === 0" class="playback-field playback-field-empty">
        No fields match current search.
      </div>
      <div v-for="field in filteredFields" v-else :key="field.label" class="playback-field">
        <div class="playback-field-content">
          <strong class="playback-field-name">
            {{ field.label }}
          </strong>
          <span class="playback-field-example">
            {{ field.value }}
          </span>
        </div>
        <Button
          compact
          label="Add this field"
          @click="onFieldUse(field.label)"
        />
      </div>
    </div>
    <div class="playback-field-hint">
      You may use the alternative delimiters "[" and "]" to add prepositions to the playback fields. So for instance "[EncounterDischargeTime]" will translate to "on June 21, 2016".
      <p>By default a space will be added just before each playback field if one is not already included. To disable this behavior include an exclamation point before the field name. So the text "https://myhospital.com/&lt;!EncounterId&gt;" will be translated to "https://myhospital.com/abc123" instead of "https://myhospital.com/ abc123"
      </p>
    </div>
  </SearchDropdown>
</template>

<style lang="scss" scoped>
.playback-field-picker {
  margin-left: auto;
}

.playback-field-content {
  overflow: auto;
  padding-right: 16px;
}

.playback-field-name {
  font-weight: $fw-regular;
}

.playback-field-example {
  color: $fc-html-light;
  display: block;
  font-size: $fs-secondary;
  word-break: break-all;
}

.playback-field-container {
  border-bottom: $br-light;
  max-height: 350px;
  overflow: auto;
  padding: 0 0 16px;
}

@include picker-item('.playback-field');
$dropdown-width: 430px;
$group-margin: 2px;
$separator-height: 1px;

.playback-field {
  margin: $group-margin;
  width: $dropdown-width;

  & + .playback-field {
    margin-top: 2 * $group-margin + $separator-height;

    &::before {
      top: -($group-margin + $separator-height);
    }
  }
}

.playback-field-hint {
  color: $fc-html-light;
  display: block;
  font-size: $fs-secondary;
  padding: 16px;
  width: $dropdown-width;

  p {
    padding-top: 16px;
  }
}
</style>
